export default "__VITE_ASSET__iWGIsxa4__"